import {
  LegendItem,
  LegendItemWrapper,
  StyledCell,
  StyledHeader,
  StyledLegend,
} from './styles'
import { CustomLegendPropsType } from './types'

const CustomLegend: React.FC<CustomLegendPropsType> = ({
  payload,
  svgPatternMap,
}) => {
  const formatLegendLabels = (value: string, _: any, __: any) => {
    const match = value.match(/pattern(\d+)/)
    if (match) {
      const patternId = `pattern${match[1]}`
      const pattern = Array.from(svgPatternMap).find(
        ([_, value]) => Array.isArray(value) && value[0] === patternId
      )

      return pattern ? pattern[0] : value
    }
    return value
  }

  return (
    <StyledLegend>
      <StyledHeader>
        <StyledCell></StyledCell>
        <StyledCell>
          SpO<sub>2</sub>
        </StyledCell>
        <StyledCell>HR</StyledCell>
        <StyledCell>RR</StyledCell>
        <StyledCell>T</StyledCell>
        <StyledCell>BP</StyledCell>
      </StyledHeader>
      <LegendItemWrapper>
        {payload.map((entry: { value: string }, index: any) => {
          const legendLabel = formatLegendLabels(entry.value, null, null)

          return (
            <LegendItem key={`item-${index}`}>
              <StyledCell>
                <svg width='30' height='30' style={{ borderRadius: '100%' }}>
                  <rect width='30' height='30' fill={`url(#${entry.value})`} />
                </svg>
              </StyledCell>
              <StyledCell>{legendLabel[0]}</StyledCell>
              <StyledCell>{legendLabel[1]}</StyledCell>
              <StyledCell>{legendLabel[2]}</StyledCell>
              <StyledCell>{legendLabel[3]}</StyledCell>
              <StyledCell>{legendLabel[4]}</StyledCell>
            </LegendItem>
          )
        })}
      </LegendItemWrapper>
    </StyledLegend>
  )
}

export default CustomLegend
